import { Input, Modal as ModalANTD } from "antd";
import styled, { css } from "styled-components";

const SearchANTD = Input.Search;

export const Modal = styled(ModalANTD)`
  .ant-btn.ant-btn-primary:hover {
    opacity: 0.8;
  }

  .ant-btn {
    span {
      color: #1a1a1a !important;
    }
  }

  .button.ant-btn.ant-input-search-button.ant-btn-primary,
  .ant-btn-primary,
  .ant-btn-primary:hover {
    span {
      color: ${({ theme }) => theme.colors?.btnTextColor} !important;
    }
  }

  .ant-btn.ant-btn-primary,
  .ant-input-search-button,
  .ant-checkbox-checked .ant-checkbox-inner {
    border-color: ${({ theme }) => theme.colors.primary};
    background-color: ${({ theme }) => theme.colors.primary};
  }

  .ant-checkbox-checked:after,
  .ant-checkbox-checked:before {
    border-color: ${({ theme }) => theme.colors.primary};
  }

  .ant-modal-header {
    border-radius: 20px 20px 0px 0px;
  }

  .ant-spin {
    margin: 0;
    width: 100%;
    height: 150px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .ant-list-item-meta-title {
    overflow: hidden;
    width: max-content;
    max-height: 50px;
    max-width: 250px;
  }

  ${({ theme }) =>
    theme.mode === "dark" &&
    css`
      .ant-input {
        color: #e7e7e7;
      }

      .ant-btn.ant-input-search-button.ant-btn-primary {
        background: ${({ theme }) => theme.colors.primary} !important;
      }

      .ant-modal-content {
        background: #303030 !important;

        textarea {
          border: none;
          background: #282828 !important;
          color: #e7e7e7;
        }

        ul.ant-list-items {
          > div {
            border: 2px solid #404040;

            a,
            span {
              color: #eeeeee;
            }
          }
        }

        button.ant-btn {
          border: none;
        }

        .ant-modal-close {
          color: ${({ theme }) =>
            theme.mode === "dark" && "#F1F1F1 !important"};
        }

        .ant-input-group-addon {
          border: none !important;
        }
      }

      .ant-modal-header {
        background: #303030 !important;
        border-bottom: 1px solid #000000;
      }

      .ant-modal-title {
        color: #ffffff;
      }
    `}

  @media (max-width: 800px) {
    top: 0;
    right: 0;
    width: 100vw !important;
    max-width: 100vw;
    margin: 0;
    padding: 0;

    .ant-modal-body {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 90vh;
    }

    .ant-modal-content {
      height: 100vh;
      margin: 0;
      padding: 0;
      border-radius: 0;
    }
  }
`;

export const Search = styled(SearchANTD)`
  ${(props) =>
    !props.enterButton &&
    css`
      .ant-input-group-addon {
        display: none;
      }

      input {
        border-top-right-radius: 8px !important;
        border-bottom-right-radius: 8px !important;
      }
    `};

  .ant-input {
    color: ${({ theme }) => (theme.mode === "dark" ? "#F1F1F1" : "#545454")};
    border-color: ${({ theme }) => theme.colors?.inputBackgroundColor};
    background-color: ${({ theme }) => theme.colors?.inputBackgroundColor};
  }
`;

export const ContentButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 1.5rem;
`;

export const ContentForm = styled.div`
  display: flex;
  flex-direction: column;

  margin-top: 20px;

  .has-error {
    ant-input {
      border-color: red;
    }
  }

  .ant-legacy-form-explain {
    height: 0;
  }

  .has-error .ant-legacy-form-explain,
  .has-error .ant-legacy-form-split {
    color: #ff4d4f;
  }

  .has-error .ant-input {
    border-color: #ff4d4f;
  }
`;
